import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { LayoutProvider } from '../../layout/core'
import LoadingSpinner from '../LoadingSpinner'

const App: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <LayoutProvider>
        <Outlet />
      </LayoutProvider>
    </Suspense>
  )
}

export default App
